import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-final-form';

import UnsavedModal from '../../../../components/unsaved-modal/UnsavedModal';
import useRedirectPrompt from '../../../../hooks/useRedirectPrompt';

const CustomerUnsavedChangesModal = ({ onSubmit, onDontSave }) => {
  const { dirty, valid, submitting, values } = useFormState();
  const [isShowUnsavedModal, setIsShowUnsavedModal] = useState(false);

  const isDirty = useMemo(
    () => dirty || values.companyUsers.length || values.enabledProducts.length || values.assignedProjects.length,
    [values, dirty],
  );

  const [showPrompt, confirmNavigation, cancelNavigation] = useRedirectPrompt(isDirty && !submitting);

  const handleCancelModal = useCallback(() => {
    setIsShowUnsavedModal(false);

    if (showPrompt) {
      cancelNavigation();
    }
  }, [showPrompt, cancelNavigation]);

  const handleDontSave = useCallback(() => {
    setIsShowUnsavedModal(false);

    if (onDontSave) {
      onDontSave();
    }

    if (showPrompt) {
      confirmNavigation();
    }
  }, [showPrompt, confirmNavigation, onDontSave]);

  const handleSaveModal = useCallback(() => {
    setIsShowUnsavedModal(false);
    onSubmit();

    if (valid && showPrompt) {
      confirmNavigation();
    }

    if (!valid && showPrompt) {
      cancelNavigation();
    }
  }, [showPrompt, confirmNavigation, onSubmit, valid, cancelNavigation]);

  useEffect(() => {
    setIsShowUnsavedModal(showPrompt);
  }, [showPrompt]);

  return (
    <UnsavedModal
      isOpen={isShowUnsavedModal}
      onCancel={handleCancelModal}
      onClose={handleCancelModal}
      onDontSave={handleDontSave}
      onSave={handleSaveModal}
    />
  );
};

export default CustomerUnsavedChangesModal;
